<div class="table-header-action flex-row">
  <button
    id="filter-dropdown"
    class="filter-container"
    (click)="isfilterDropdownHeaderOpen = !isfilterDropdownHeaderOpen"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
  >
    <sh-text class="event-date"> {{ labelDropdown() }}</sh-text>
    <sh-icon icon="arrow-face-down-s"></sh-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isfilterDropdownHeaderOpen"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="overlayOpenNext(false)"
    (overlayKeydown)="onOverlayKeydown($event)"
    (detach)="overlayOpenNext(false)"
  >
    <div class="event-item-group filter-overlay">
      <div>
        <div class="event-item">
          <sh-checkbox
            label="{{ 'cts.gantry.errors' | translate }}"
            [active]="filterLogService.filter.errors"
            (checked)="
              filterLogService.onErrorCheck(
                $event.target.hasAttribute('active')
              )
            "
          ></sh-checkbox>
        </div>
        <div class="event-item">
          <sh-checkbox
            label="{{ 'cts.gantry.informations' | translate }}"
            [active]="filterLogService.filter.informations"
            (checked)="
              filterLogService.onInfoCheck($event.target.hasAttribute('active'))
            "
          ></sh-checkbox>
        </div>
        <div class="event-item">
          <sh-checkbox
            label="{{ 'cts.gantry.warnings' | translate }}"
            [active]="filterLogService.filter.warnings"
            (checked)="
              filterLogService.onWarningCheck(
                $event.target.hasAttribute('active')
              )
            "
          ></sh-checkbox>
        </div>
      </div>
    </div>
  </ng-template>
</div>
